import { Chat, getChatById, useChatStore } from "@/entities/chat";
import { useAuthStore } from "@/features/auth";

const chatNamePromiseCache = new Map<string, Promise<string>>();

export const getUserNameForChat = async (chatId: string, ownerId?: string): Promise<string> => {
  if (!chatId) return "User";

  const currentUser = useAuthStore.getState().user;

  if (chatId === currentUser?._id || ownerId === currentUser?._id) {
    return currentUser?.firstName || "User";
  }

  if (chatNamePromiseCache.has(chatId)) {
    return chatNamePromiseCache.get(chatId)!;
  }

  const promise = (async () => {
    const chat = await getChat(chatId);
    const name = chat?.contact?.firstName || "User";
    return name;
  })();

  chatNamePromiseCache.set(chatId, promise);

  return promise;
};


const getChat = async (chatId: string) => {
  const state = useChatStore.getState();

  const chatFromStore = state.chats.find(
    (chat: Chat) => chat._id === chatId
  );

  if (chatFromStore) {
    return chatFromStore;
  }

  const res = await getChatById(chatId);

  if (res.success) {
    return res.result;
  }

  return null;
};
